import Chart from 'chart.js/auto';

const charts = new Map();

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.provider-problems-card').forEach((block) => {
        const canvas = block.querySelector('canvas');
        if (!canvas) return;

        const complaints = JSON.parse(block.dataset.complaints);
        const dates = JSON.parse(block.dataset.dates);
        const color = block.dataset.color || '#e74c3c';

        const chart = new Chart(canvas.getContext('2d'), {
            type: 'line',
            data: {
                labels: dates,
                datasets: [{
                    label: 'Жалобы',
                    data: complaints,
                    borderColor: color,
                    backgroundColor: 'rgba(0,0,0,0)',
                    pointBackgroundColor: color,
                    fill: false,
                    tension: 0.4,
                    borderWidth: 3,
                    pointRadius: 4,
                    pointHoverRadius: 6
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        display: true,
                        grid: {
                            display: false
                        },
                        ticks: {
                            color: '#000',
                            font: {
                                size: 14,
                                weight:600
                            }
                        }
                    },
                    y: {
                        display: false,
                        beginAtZero: true
                    }
                },
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        backgroundColor: 'rgba(0,0,0,0.8)',
                        titleColor: '#fff',
                        bodyColor: '#fff',
                        borderColor: color,
                        borderWidth: 1
                    }
                },
                interaction: {
                    intersect: false,
                    mode: 'index'
                }
            }
        });
        charts.set(block.querySelector('button').dataset.id, chart);
    });

    document.querySelectorAll('.provider-problems-card__complain-btn').forEach(btn => {
        const providerUri = btn.dataset.id;
        if (hasComplained(providerUri)) {
            btn.disabled = true;
            btn.textContent = 'Жалоба отправлена';
        }

        btn.addEventListener('click', function () {
            if (btn.disabled) return;

            const originalText = btn.textContent;
            btn.textContent = 'Отправка...';
            btn.disabled = true;

            fetch('/provider-complaints', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({ provider_id: providerUri })
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response not ok');
                }
                return response.json();
            })
            .then(data => {
                setComplained(providerUri);
                btn.disabled = true;
                btn.textContent = 'Жалоба отправлена';

                const complaintsCountElement = btn.closest('.provider-problems-card').querySelector('.provider-problems-card__complaints-count');
                if (complaintsCountElement) {
                    const currentCount = parseInt(complaintsCountElement.textContent.match(/\d+/)[0]);
                    complaintsCountElement.textContent = `${currentCount + 1} жалоб`;
                }

                const chart = charts.get(providerUri);
                if (chart) {
                    const data = chart.data.datasets[0].data;
                    data[data.length - 1] += 1;
                    chart.update();
                }
            })
            .catch(error => {
                console.error('Error:', error);
                btn.textContent = originalText;
                btn.disabled = false;
            });
        });
    });
});

function hasComplained(providerId) {
    const value = localStorage.getItem('complaint_' + providerId);
    if (!value) return false;
    return (Date.now() - parseInt(value, 10)) < 24 * 60 * 60 * 1000;
}

function setComplained(providerId) {
    localStorage.setItem('complaint_' + providerId, Date.now());
}
